import { useState, useEffect } from 'react';
import { generateDefaultSnapshotName } from '../../utils/snapshot';

export function useSnapshotName(migrationName: string, initial?: string, label: string = 'Snapshot') {
  const [snapshotName, setSnapshotName] = useState<string>(
    initial ?? generateDefaultSnapshotName(migrationName, label)
  );
  const [snapshotNameEdited, setSnapshotNameEdited] = useState<boolean>(Boolean(initial));

  useEffect(() => {
    if (!snapshotNameEdited) {
      setSnapshotName(generateDefaultSnapshotName(migrationName, label));
    }
  }, [migrationName, snapshotNameEdited, label]);

  return { snapshotName, setSnapshotName, snapshotNameEdited, setSnapshotNameEdited } as const;
}

export default useSnapshotName;
